import React, { useEffect, useState } from "react";
import Testimonial from './Testimonial';

const userTestimonials = [
  {
    quote: 'As a first-time author, I found the Cureus process refreshingly supportive and intuitive. From submission to publication, their guidance made every step clear and manageable. I truly appreciated how seamless and encouraging the experience was — perfect for anyone new to academic publishing.',
    name: 'Dr. Danielle C. Durant',
    affiliation: 'Emergency Medicine | Cambridge University Hospitals',
    profilePicture: 'https://public.cureus.com/user_testimonials/DanielleDurant.jpeg'
  },
  {
    quote: 'Cureus handles papers quickly and carefully. The system for submission and editing was easy to understand and simple to use. Another major benefit is how easily your research can reach a global audience. For first-time authors, I would say don’t hesitate. Cureus provides a user-friendly platform that makes publishing efficient and accessible.',
    name: 'Mototsugu Kudo, MSc, Critical Care',
    affiliation: 'Sapporo Medical University | Sapporo, Japan',
    profilePicture: 'https://public.cureus.com/user_testimonials/MototsuguKudo.jpeg',
  },
  {
    quote: 'I would recommend Cureus because of its efficient publication process, clear communication, and suitability for clinical case reports.',
    name: 'Chen-yu Chang, MD, Fellow Physician and Research Assistant',
    affiliation: 'Pediatrics | Changhua Christian Hospital | Changhua, Taiwan',
    profilePicture: 'https://public.cureus.com/user_testimonials/ChenYu.jpeg',
  },
  {
    quote: "I enjoy the platform's ease and speed of reviews and publication. Submitting the paper directly into the platform is much easier than creating pdfs from a word document as other journals do. I also enjoyed the way the reviewer comments are sent, directly on the paper.",
    name: 'Joanne N. Quinones, MD, Associate Professor',
    affiliation: 'Obstetrics and Gynecology | Maternal Fetal Medicine | Lehigh Valley Health Network | Allentown, USA',
    profilePicture: 'https://public.cureus.com/user_testimonials/JoanneNQuinones.png',
  },
  {
    quote: "By far the most author-friendly experience I've ever had in academic medicine. Who would have thought a journal would care about customer service?",
    name: 'Thomas Hickey, MD, MSc',
    affiliation: 'Anesthesiology, Addiction Medicine | Yale University School of Medicine, VA Connecticut Healthcare System | West Haven, USA',
    profilePicture: 'https://public.cureus.com/user_testimonials/ThomasHickey.jpeg',
  },
  {
    quote: 'Through the process, the article progress was handled in a professional manner and the details were communicated and also made available on the dashboard of the submission portal. The reviewers meticulously guided us to improve the quality of our article.',
    name: 'Ajay Bommareddy, PhD, Associate Professor',
    affiliation: 'Pharmacology | Department of Biomedical Science | Charles E Schmidt College of Medicine | Florida Atlantic University | Florida, USA',
    profilePicture: 'https://public.cureus.com/user_testimonials/AjayBommareddy.jpeg',
  },
  {
    quote: 'Cureus offers very good guidance and fast responses to questions. I found it very helpful as this was my first publication as first author.',
    name: 'Natalie Burkhardt, Medical Student',
    affiliation: 'Family and Community Medicine | Oceania University of Medicine | Whangarei, New Zealand',
    profilePicture: 'https://public.cureus.com/user_testimonials/NatalieBurkhardt.jpeg',
  },
  {
    quote: 'I highly recommend Cureus to colleagues due to their friendly peer review, flawless editorial handling, and user-friendly submission and review systems. The journal provides an excellent platform for researchers and clinicians to share their work, and the overall experience is seamless and supportive.',
    name: 'Safin Hussein, PhD',
    affiliation: 'Department of Biology | University of Raparin | Ranya, Iraq',
    profilePicture: 'https://public.cureus.com/user_testimonials/SafinHussein.png',
  },
]

const UserTestimonial = ({}) => {

  const [visibleIndex, setVisibleIndex] = useState(0);
  const [initialRender, setInitialRender] = useState(true);

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false)
    }

    $(".orbit-container").on("after-slide-change.fndtn.orbit", function(event, orbit) {
      setVisibleIndex(orbit.slide_number);
    });
    $(document).foundation('orbit', 'reflow');
  })

  const leftArrow = (className = "left-arrow show-for-large-up") => {
    const leftActive = visibleIndex > 0
    return (
      <a
        className={className}
        data-orbit-link={visibleIndex - 1}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'>
          <path
            d='M21 11.9999H3M3 11.9999L10 5M3 11.9999L10 18.9999'
            stroke={leftActive ? "black" : "#D6D9DC"}
            strokeWidth='1.5'
            strokeLinecap='square'/>
        </svg>
      </a>
    )
  }

  const rightArrow = (className = "right-arrow show-for-large-up") => {
    const rightActive = visibleIndex <  userTestimonials.length - 1
    return (
      <a
        className={className}
        data-orbit-link={visibleIndex + 1}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'>
          <path
            d='M3 11.9999H21M21 11.9999L14 5M21 11.9999L14 18.9999'
            stroke={rightActive ? "black" : "#D6D9DC"}
            strokeWidth='1.5'
            strokeLinecap='square'/>
        </svg>
      </a>
    )}

  const mobileControls = () => {
    return (
      <div className="carousel-controls show-for-medium-down">
        {leftArrow('left-arrow')}
        {rightArrow('right-arrow')}
      </div>
    )
  }

  return (
    <div className='user-testimonial'>
      {leftArrow()}
      <div className="outer-border-container">
        <div className='border-container'>
          <div className="inner-border-container">
            <ul
              className='slides-container'
              data-orbit
              data-options="animation:slide; animation_speed:500; bullets:false; slide_number:false; timer:true; timer_speed:8000; pause_on_hover:false; circular: true; navigation_arrows:false;">
              {userTestimonials.map(({quote, name, affiliation, profilePicture}, index) => {
                return (
                  <Testimonial
                    key={index}
                    index={index}
                    quote={quote}
                    name={name}
                    affiliation={affiliation}
                    profilePicture={profilePicture}
                  />
                )
              })}
            </ul>
          </div>
        </div>
      </div>
      {rightArrow()}
      {mobileControls()}
    </div>
  )
}

export default UserTestimonial;